import * as tslib_1 from "tslib";
/* eslint no-unused-expressions:0 */
import styled from '../styles';
import BaseButtonStyle from './BaseButtonStyle';
import withRipple from './withRipple';
var BaseButton = styled(withRipple('button'))(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), BaseButtonStyle);
BaseButton.displayName = 'BaseButton';
BaseButton.sinouiName = 'BaseButton';
export default BaseButton;
var templateObject_1;
//# sourceMappingURL=BaseButton.js.map